import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </Comp>
  );
};

const LINE = { hidden: { y: "110%" }, show: { y: "0%" } };

export const MaskLine = ({ children, delay = 0, inView = false, className = "" }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.15 } }
    : { animate: "show" };
  return (
    <motion.span initial="hidden" {...trigger} className={`block overflow-hidden pb-[0.12em] -mb-[0.12em] ${className}`}>
      <motion.span className="block" variants={LINE} transition={{ duration: 1.1, delay, ease: EASE }}>
        {children}
      </motion.span>
    </motion.span>
  );
};
